import React, {useRef, useState} from 'react'
import styles from './styles.module.css'
import Container from '@packages/justo-parts/lib/components/Container'
import Loading from '@packages/justo-parts/lib/components/Loading'
import {Document, Page} from 'react-pdf/dist/esm/entry.webpack'
import range from 'lodash/range'
import useWidth from '@hooks/useWidth'
import DynamicPage from './DynamicPage'
import CollectEmail from './CollectEmail'
import {getWebsiteEMenu_emenu} from '@data/queries/website/__generated__/getWebsiteEMenu'
import NoSSR from '@components/NoSSR'
import SuspenseLoading from '@components/SuspenseLoading'
import PDFViewer from '@components/PdfViewer'

export interface EMenuProps {
  emenu: getWebsiteEMenu_emenu
}

export default function EMenu(props: EMenuProps) {
  const {emenu} = props

  const [numPages, setNumPages] = useState(null)

  function onDocumentLoadSuccess({numPages}) {
    setNumPages(numPages)
  }

  // to listen to resizes
  useWidth()

  if (!emenu) return null
  if (!emenu.file) return null

  return (
    <>
      {emenu.collectEmails ? <CollectEmail emenu={emenu} /> : null}
      <div className={styles.container}>
        <NoSSR>
          <SuspenseLoading>
            <DynamicPage emenuId={emenu._id} />
          </SuspenseLoading>
        </NoSSR>
        <Container>
          <PDFViewer file={emenu.file.url} />
        </Container>
      </div>
    </>
  )
}
